import BaseTableCell from '@material-ui/core/TableCell'

const TableCell = BaseTableCell

export default TableCell
